import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=f5ea39c0&"
import script from "./DataTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=f5ea39c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports